<template>
    <tr>
        <td>
            <router-link :to="orderDetailsLink"
            >#{{ ordernumber }}</router-link
            >
        </td>
        <td>{{ orderdate }}</td>
        <td>{{ orderstatus }}</td>
        <td>{{ toUSD(ordertotal) }}</td>
        <td></td>
        <td></td>
    </tr>
</template>

<script>
import Price from '../../../mixins/price.js';

export default {
    props: {
        ordernumber: {
            type: Number,
            required: true
        },
        orderdate: {
            type: String
        },
        orderstatus: {
            type: String
        },
        ordertotal: {
            type: Number,
            default: 0
        },
    },
    mixins: [Price],
    computed: {
        orderDetailsLink() {
            return this.$route.path + '/' + this.ordernumber;
        },
    }
}
</script>